import {
	Card,
	CardContent,
	CardHeader,
	CardTitle,
} from "@/components/primitives";
import { AlertCircle, Target } from "lucide-react";
import type { Reflection } from "../types";

interface ReflectionStatesProps {
	reflection: Reflection;
}

export function ReflectionStates({ reflection }: ReflectionStatesProps) {
	if (!reflection.current_state && !reflection.future_state) {
		return null;
	}

	return (
		<div className="space-y-6 print-full-width">
			{reflection.current_state && (
				<Card className="border-2 shadow-xl bg-white/90 dark:bg-slate-800/90 backdrop-blur-sm">
					<CardHeader className="pb-4 border-b bg-gradient-to-r from-red-50/50 to-orange-50/50 dark:from-red-950/20 dark:to-orange-950/20">
						<div className="flex items-center gap-3">
							<div className="p-2 rounded-lg bg-gradient-to-br from-red-500 to-orange-600">
								<AlertCircle className="h-5 w-5 text-white" />
							</div>
							<div>
								<CardTitle className="text-xl sm:text-2xl font-semibold">
									Current State
								</CardTitle>
							</div>
						</div>
					</CardHeader>
					<CardContent className="pt-6">
						<p className="text-foreground leading-relaxed">
							{reflection.current_state}
						</p>
					</CardContent>
				</Card>
			)}
			{reflection.future_state && (
				<Card className="border-2 shadow-xl bg-white/90 dark:bg-slate-800/90 backdrop-blur-sm">
					<CardHeader className="pb-4 border-b bg-gradient-to-r from-green-50/50 to-emerald-50/50 dark:from-green-950/20 dark:to-emerald-950/20">
						<div className="flex items-center gap-3">
							<div className="p-2 rounded-lg bg-gradient-to-br from-green-500 to-emerald-600">
								<Target className="h-5 w-5 text-white" />
							</div>
							<div>
								<CardTitle className="text-xl sm:text-2xl font-semibold">
									Future State
								</CardTitle>
							</div>
						</div>
					</CardHeader>
					<CardContent className="pt-6">
						<p className="text-foreground leading-relaxed">
							{reflection.future_state}
						</p>
					</CardContent>
				</Card>
			)}
		</div>
	);
}
